export const getPlugin = (api, context, pluginName) => {
  return api.plugins.getInstance(context, pluginName);
};



// WEBPACK FOOTER //
// ./src/shared/stores/uScope/plugin-access.js